import React from "react";
import { MapPin, Mail, MessageCircle, Instagram, Facebook, Linkedin } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_admissions-roadmap/artifacts/2ac8oce6_Mindways%20logo.png";
const CALENDLY_URL = "https://cal.com/mindways/discovery-call";

const socials = [
  { icon: Instagram, href: "https://www.instagram.com/mindwaysstudyabroad/?hl=en", label: "Instagram" },
  { icon: Facebook, href: "https://www.facebook.com/MindwaysStudyAbroadVisa/", label: "Facebook" },
  { icon: Linkedin, href: "https://www.linkedin.com/in/anirudh101/", label: "LinkedIn" },
];

const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Tracks", href: "#tracks" },
  { label: "Destinations", href: "#destinations" },
  { label: "Why Mindways", href: "#why-mindways" },
  { label: "Results", href: "#outcomes" },
  { label: "FAQs", href: "#faq" },
];

export default function Footer({ onBookCall }) {
  const handleNav = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      id="footer"
      data-testid="footer"
      style={{ backgroundColor: "#2B2F9E", color: "#fff" }}
    >
      {/* Main footer */}
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "72px 24px 48px" }}>
        <div className="mw-grid-footer">

          {/* Brand */}
          <div>
            <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "8px 10px", display: "inline-block", marginBottom: "20px" }}>
              <img src={LOGO} alt="Mindways" style={{ height: "72px", width: "auto", display: "block" }} />
            </div>
            <p style={{ fontSize: "15px", color: "rgba(255,255,255,0.75)", fontFamily: "'DM Sans', sans-serif", lineHeight: "1.7", margin: "0 0 20px", maxWidth: "280px" }}>
              Studying Overseas Simplified. Founder-led overseas education counselling since 2005.
            </p>
            <button
              data-testid="footer-book-call-btn"
              onClick={() => window.open(CALENDLY_URL, "_blank")}
              style={{
                backgroundColor: "#F5A000",
                color: "#fff",
                border: "none",
                padding: "12px 24px",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "700",
                cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = "#d98e00"; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = "#F5A000"; }}
            >
              Book a Strategy Call
            </button>

            {/* Social icons */}
            <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
              {socials.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  aria-label={label}
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    border: "1px solid rgba(255,255,255,0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "rgba(255,255,255,0.8)",
                    textDecoration: "none",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#F5A000"; e.currentTarget.style.borderColor = "#F5A000"; e.currentTarget.style.color = "#fff"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)"; e.currentTarget.style.color = "rgba(255,255,255,0.8)"; }}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "12px", fontWeight: "700", letterSpacing: "0.12em", textTransform: "uppercase", color: "rgba(255,255,255,0.5)", margin: "0 0 20px" }}>
              Navigation
            </h4>
            <nav style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  data-testid={`footer-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={(e) => handleNav(e, link.href)}
                  style={{
                    color: "rgba(255,255,255,0.75)",
                    textDecoration: "none",
                    fontSize: "15px",
                    fontFamily: "'DM Sans', sans-serif",
                    transition: "color 0.2s",
                  }}
                  onMouseEnter={(e) => { e.target.style.color = "#fff"; }}
                  onMouseLeave={(e) => { e.target.style.color = "rgba(255,255,255,0.75)"; }}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h4 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "12px", fontWeight: "700", letterSpacing: "0.12em", textTransform: "uppercase", color: "rgba(255,255,255,0.5)", margin: "0 0 20px" }}>
              Legal
            </h4>
            <nav style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {[
                { label: "Privacy Policy", href: "/privacy-policy" },
                { label: "Terms of Service", href: "/terms-of-service" },
                { label: "Cookie Policy", href: "/cookie-policy" },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  data-testid={`footer-legal-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  style={{ color: "rgba(255,255,255,0.75)", textDecoration: "none", fontSize: "15px", fontFamily: "'DM Sans', sans-serif", transition: "color 0.2s" }}
                  onMouseEnter={(e) => { e.target.style.color = "#fff"; }}
                  onMouseLeave={(e) => { e.target.style.color = "rgba(255,255,255,0.75)"; }}
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "12px", fontWeight: "700", letterSpacing: "0.12em", textTransform: "uppercase", color: "rgba(255,255,255,0.5)", margin: "0 0 20px" }}>
              Contact Us
            </h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              <a
                href="https://maps.app.goo.gl/qax3vzaNJMVVHdz46"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address-link"
                style={{ display: "flex", gap: "10px", alignItems: "flex-start", textDecoration: "none" }}
              >
                <MapPin size={16} style={{ color: "#F5A000", marginTop: "2px", flexShrink: 0 }} />
                <span style={{ fontSize: "14px", color: "rgba(255,255,255,0.75)", fontFamily: "'DM Sans', sans-serif", lineHeight: "1.5", transition: "color 0.2s" }}
                  onMouseEnter={(e) => { e.target.style.color = "#fff"; }}
                  onMouseLeave={(e) => { e.target.style.color = "rgba(255,255,255,0.75)"; }}>
                  1106 Chiranjiv Tower, 43 Nehru Place,<br />New Delhi 110019
                </span>
              </a>
              <a
                href="mailto:study@mindways.in"
                data-testid="footer-email-link"
                style={{ display: "flex", gap: "10px", alignItems: "center", color: "rgba(255,255,255,0.75)", textDecoration: "none", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", transition: "color 0.2s" }}
                onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.75)"; }}
              >
                <Mail size={16} style={{ color: "#F5A000", flexShrink: 0 }} />
                study@mindways.in
              </a>
              <a
                href="https://wa.me/919821916960"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                style={{ display: "flex", gap: "10px", alignItems: "center", color: "rgba(255,255,255,0.75)", textDecoration: "none", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", transition: "color 0.2s" }}
                onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.75)"; }}
              >
                <MessageCircle size={16} style={{ color: "#F5A000", flexShrink: 0 }} />
                WhatsApp: +91 98219 16960
              </a>
            </div>

            {/* Office hours */}
            <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.5)", fontFamily: "'DM Sans', sans-serif", marginTop: "20px" }}>
              Mon–Sat: 10:00 AM – 6:00 PM IST
            </p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.12)", padding: "20px 24px" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
          <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.5)", fontFamily: "'DM Sans', sans-serif", margin: 0 }}>
            © {new Date().getFullYear()} Mindways Consulting Pvt. Ltd. All rights reserved. Est. 2005.
          </p>
          <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.4)", fontFamily: "'DM Sans', sans-serif", margin: 0 }}>
            Registered: New Delhi, India
          </p>
        </div>
      </div>
    </footer>
  );
}
